import { render, staticRenderFns } from "./editSigningMonthPreferential.vue?vue&type=template&id=f72f6534&scoped=true&"
import script from "./editSigningMonthPreferential.vue?vue&type=script&lang=js&"
export * from "./editSigningMonthPreferential.vue?vue&type=script&lang=js&"
import style0 from "./editSigningMonthPreferential.vue?vue&type=style&index=0&id=f72f6534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72f6534",
  null
  
)

export default component.exports